import { isCalendarDateLike } from './is-calendar-date-like';

/**
 * Truncates a date string to its `yyyy-MM-dd` calendar-date prefix.
 *
 * @throws when the value does not start with a `yyyy-MM-dd` shaped prefix.
 *
 * @example
 * toCalendarDate('2026-03-19T23:00:00.000Z'); // '2026-03-19'
 * toCalendarDate('2026-03-19');               // '2026-03-19'
 */
export function toCalendarDate(date: string): string {
  const calendarDate = date.slice(0, 10);

  if (!isCalendarDateLike(calendarDate)) {
    throw new Error(`Expected a yyyy-MM-dd prefixed date, got "${date}".`);
  }

  return calendarDate;
}
